import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CardMedia from '@mui/material/CardMedia';
import { useBreakpoint } from '@rakutenfrance/breakpoint';
import { mobileContainer, container, backgroundImgMobileContainer, backgroundImgContainer, backgroundImgMobile, backgroundImg, textContainerMobile, textContainer, title, text, } from './Card.style';
export const Card = ({ backgroundLink, children, name, isActive, isPremium = false, logoBackgroundColor = '#ffffff', }) => {
    const { breakpoint } = useBreakpoint();
    const isDeviceMobile = breakpoint === 'phone';
    return (React.createElement(Box, { sx: isDeviceMobile && isActive ? mobileContainer : container },
        React.createElement(Box, { sx: isActive ? backgroundImgMobileContainer(isPremium, logoBackgroundColor) : backgroundImgContainer(isPremium, logoBackgroundColor) },
            React.createElement(CardMedia, { component: "img", sx: isActive ? backgroundImgMobile(isPremium, logoBackgroundColor) : backgroundImg(isPremium, logoBackgroundColor), image: backgroundLink, alt: name })),
        React.createElement(Box, { sx: isDeviceMobile && isActive ? textContainerMobile : textContainer },
            React.createElement(Typography, { sx: title(isDeviceMobile) }, name),
            React.createElement(Typography, { sx: text }, children))));
};
